module.exports = __webpack_public_path__ + "img/icon-82.c6fbbcc7.png";